import { getUserCenterPageRoute, UserCenterRoutes } from '@/constants/PageRoutes'
import { USER_CENTER_CONFIG } from '@/project-config'
import { useAssetsStore, useDoubleContractAssetsAccountStore } from 'store'
import { RouterView } from 'vue-router'
import './UserCenterView.scss'

const noFetchDoubleAssetRoutePaths = [getUserCenterPageRoute(UserCenterRoutes.FinancialHistory), getUserCenterPageRoute(UserCenterRoutes.AssetFinance)]

const UserCenterView = defineComponent({
  name: 'UserCenterView',
  setup() {
    const assetsStore = useAssetsStore()
    const route = useRoute()
    const doubleContractAssetsAccountStore = useDoubleContractAssetsAccountStore()

    onBeforeMount(() => {
      assetsStore.fetchData()
      if (!noFetchDoubleAssetRoutePaths.includes(route.path as UserCenterRoutes)) {
        doubleContractAssetsAccountStore.fetchData()
      }
    })

    onBeforeUnmount(() => {
      assetsStore.stopFetchData()
      doubleContractAssetsAccountStore.stopFetchData()
    })

    return () => (
      <div class="user-center-view-layout">
        {USER_CENTER_CONFIG.AsideMenu && <USER_CENTER_CONFIG.AsideMenu />}
        <div class="user-router-view">
          <RouterView></RouterView>
        </div>
      </div>
    )
  },
})

export default UserCenterView
